import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import numeral from 'numeral';


const AdminFileOrderTable = props => {

    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 50,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'NO RESI',
        accessor: 'waybillId',
    },{
        Header: 'PENGIRIM',
        accessor: 'originName',
        Cell: ({row,original}) => originCell(original)
    },{
        Header: 'PENERIMA',
        accessor: 'receiverName',
        Cell: ({row,original}) => receiverCell(original)
    },{
        Header: 'BARANG',
        minWidth: 200,
        accessor: 'items',
        Cell: ({row,original}) => itemCell(original)
    },{
        Header: 'NOMINAL(Rp)',
        accessor: 'price',
        Cell: ({row,original}) => priceCell(original)
    },{
        Header: 'KURIR',
        accessor: 'courierCompany',
        Cell: ({row,original}) => courierCell(original)
    },{
        Header: 'TANGGAL PENGIRIMAN',
        headerStyle: { 'whiteSpace': 'unset'},
        accessor: 'deliveryDate',
        Cell: ({row,original}) => timeCell(original)
    }];

    const itemCell = (og) => {
        let items = og.items;
        return (
            <div>
                {
                    items.map((i,idx) => {
                        let name;
                        if (i.description) {
                            name = (<div><b>{i.name}</b> - {i.description}</div>)
                        } else {
                            name = (<div><b>{i.name}</b></div>)
                        }
                        return (
                            <div
                                key={idx}
                                style={{fontSize:10}}
                                className="border p-1 bg-lighter rounded text-wrap mb-1">
                                { name }
                                SKU {i.sku} <br/>
                                Harga Rp. {numeral(i.value).format("0,0")} <br/>
                                Jumlah {i.quantity} <br/>
                                Berat {i.weight}
                            </div>
                        )
                    })
                }
            </div>
        )
    };

    const priceCell = (og) => {
        return (
            <div>
                Rp. {numeral(og.price).format("0,0")}
            </div>
        )
    };

    const courierCell = (og) => {
        return (
            <div>
                {og.courierCompany} - {og.courierType} <br/>
                <b>({og.status})</b>
            </div>
        )
    };

    const receiverCell = (og) => {
        return (
            <div>
                {og.receiverName} <br/>{og.receiverPhone} <br/>
                {og.receiverLocation}
            </div>
        )
    };

    const originCell = (og) => {
        return (
            <div>
                {og.originName} <br/>{og.originPhone} <br/>
                {og.originLocation}
            </div>
        )
    };

    const timeCell = (og) => {
        return (
            <div>
                {og.deliveryDate} {og.deliveryTime}
            </div>
        )
    };

    const getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            return {}
        }
        return {};
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={props.data.length || 20}
                filterable
                loading={props.loading}
                className="-striped -highlight"
                getTrProps={getTrProps}
            />
        </div>
    )
};

export default AdminFileOrderTable;